import { ON_CHANGE_DISPLAY_CONDITION } from "../../../../constants";

export const onChangeDisplayCondition = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: ON_CHANGE_DISPLAY_CONDITION, payload });
    }
};